import fsd from "../utils/images/fsd.png"
import coursera from "../utils/images/coursera.png"

export const achievementData = {
    bio : "Throughout my short career I have had achievements such as receiving in the "+ "SoyHenry "+ "bootcamp, an upper-medium certificate in English, creating my first SPA, contributing to a group project with excellent people, etc. I look forward to continuing to achieve more goals that will make me the best version of myself tomorrow, helping others and expanding my knowledge.",
    achievements : [
        {
            id : 1,
            title : 'SoyHenry - Full Stack Developer Course',
            details : 'For having learned and demonstrating the knowledge acquired with 700 hours of code and two approved projects.',
            date : 'Jan 4, 2023',
            field : 'Web Development',
            image : fsd
        },
        {
            id : 2,
            title : 'University of California - Irvine. "Tricky American English Pronunciation"',
            details : 'Speaking and listening course of the English language spoken in North America, differentiation and practice of confusing words...',
            date : 'Jun 26, 2021',
            field : 'Languages (English)',
            image : coursera
        },
    ]
}

// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/